// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tax-manual-country[data-v-3be91424],.tax-manual-state[data-v-3be91424]{width:49% !important}", "",{"version":3,"sources":["webpack://src/stan-vue-shared/components/Form.vue"],"names":[],"mappings":"AAAA,wEAAwE,oBAAoB","sourcesContent":[".tax-manual-country[data-v-3be91424],.tax-manual-state[data-v-3be91424]{width:49% !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
